export default __webpack_public_path__ + "static/media/Virtue.f3847830.jpg";